import { render, staticRenderFns } from "./SkeletonPlaceholder.vue?vue&type=template&id=1f64e387&scoped=true"
import script from "./SkeletonPlaceholder.vue?vue&type=script&lang=js"
export * from "./SkeletonPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./SkeletonPlaceholder.vue?vue&type=style&index=0&id=1f64e387&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f64e387",
  null
  
)

export default component.exports